/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/routes';
import store from '@/store';
import API from '@/services/commonApi';
import { PROJECTMASTER } from '@/utils/endpoint';

Vue.use(VueRouter);

export const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(_to, _from, _savedPosition) {
    return { x: 0, y: 0 };
  },
});

const navigate = function(to, _from, next) {
  if (to.matched.some(m => m.meta.auth)) {
    // If the user is not authenticated and visits
    // a page that requires authentication, redirect to the login page
    if (!store.state.auth.authenticated) {
      if (to.meta.isInternal) {
        next({
          name: 'internal.login',
        });
      } else {
        next({
          name: 'home.index',
          query: { login: true },
        });
      }
      return;
    }
  }
  // If the user [Customer] try to access internal portal
  if (store.state.auth.authenticated && !store.state.auth.isInternal && to.meta.isInternal) {
    const payload = {
      cbSuccess: () => {
        next({
          name: 'internal.login',
        });
      },
    };
    store.dispatch('auth/logout', payload);
    return;
  }
  if (to.matched.some(m => !m.meta.auth && m.meta.isInternal) && to.name.includes('internal.login')) {
    if (store.state.auth.authenticated) {
      if (store.state.auth.isInternal && store.state.auth.permissions.broker
        && store.state.auth.permissions.broker.length) {
        next({
          name: 'internal.broker.myProjects',
        });
      } else if (store.state.auth.isInternal) {
        next({
          name: 'internal.employee.inventory',
        });
      }
      return;
    }
  }
  next();
};

router.beforeEach((to, from, next) => {
  store.dispatch('auth/check');
  if (!store.state.master.projectMaster && to.meta.isInternal
    && store.state.auth.authenticated && to.meta.auth) {
    API.get(PROJECTMASTER)
      .then((response) => {
        const pm = {};
        response.forEach((item) => {
          pm[item.id] = item;
        });
        store.dispatch('master/updateProjectMaster', pm);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  navigate(to, from, next);
});

Vue.router = router;

export default {
  router,
};



// WEBPACK FOOTER //
// ./src/plugins/vue-router.js